(() => {
  const initWewokBackToTop = () => {
    const button = document.querySelector('[data-wewok-back-to-top]');

    if (!button || button.dataset.initialized === 'true') return;
    button.dataset.initialized = 'true';

    const updateVisibility = () => {
      const threshold = Math.max(420, window.innerHeight * 0.65);
      const isVisible = window.scrollY > threshold;

      button.classList.toggle('is-visible', isVisible);
      button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      button.tabIndex = isVisible ? 0 : -1;
    };

    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: 0,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    });

    let ticking = false;
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;

        window.requestAnimationFrame(() => {
          updateVisibility();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWewokBackToTop, { once: true });
  } else {
    initWewokBackToTop();
  }

  document.addEventListener('shopify:section:load', initWewokBackToTop);
})();
